// Map-specific color scheme utilities (kept separate from general component scheme)

export type MapColorSchemeValue = {
    backgroundClass: string;
    blendEffect: string;
};

const MAP_COLOR_SCHEMES: Record<string, MapColorSchemeValue> = {
    dark: {
        backgroundClass: 'bg-neutral-900',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    light: {
        backgroundClass: 'bg-white-100',
        blendEffect: 'mix-blend-screen grayscale',
    },
    primary: {
        backgroundClass: 'bg-primary-800',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'light-primary': {
        backgroundClass: 'bg-primary-900',
        blendEffect: 'mix-blend-screen grayscale',
    },
    'mid-primary': {
        backgroundClass: 'bg-primary-600',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'dark-primary': {
        backgroundClass: 'bg-primary-950',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    secondary: {
        backgroundClass: 'bg-secondary-800',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'light-secondary': {
        backgroundClass: 'bg-secondary-900',
        blendEffect: 'mix-blend-screen grayscale',
    },
    'mid-secondary': {
        backgroundClass: 'bg-secondary-600',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'dark-secondary': {
        backgroundClass: 'bg-secondary-950',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    gradient: {
        backgroundClass:
            'bg-gradient-to-b from-primary-800 from-5% to-secondary-800 to-95%',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'light-gradient': {
        backgroundClass:
            'bg-gradient-to-b from-primary-800 from-5% to-secondary-800 to-95%',
        blendEffect: 'mix-blend-screen grayscale',
    },
    'mid-gradient': {
        backgroundClass:
            'bg-gradient-to-b from-primary-600 from-5% to-secondary-600 to-95%',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'primary-gradient': {
        backgroundClass:
            'bg-gradient-to-b from-primary-500 from-5% to-primary-800 to-95%',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'secondary-gradient': {
        backgroundClass:
            'bg-gradient-to-b from-secondary-500 from-5% to-secondary-800 to-95%',
        blendEffect: 'mix-blend-screen invert grayscale',
    },
    'full-color': {
        backgroundClass: 'bg-secondary-900',
        blendEffect: '',
    },
};

export function getMapColorScheme(
    scheme: unknown = 'light'
): MapColorSchemeValue {
    const key = String(scheme || '')
        .trim()
        .toLowerCase();

    return MAP_COLOR_SCHEMES[key] || MAP_COLOR_SCHEMES.light;
}
